export const expenseConstants = {
  GET_EXPENSE: 'GET_EXPENSE',
  OPEN_EXPENSE_AGENT_CHAT: 'OPEN_EXPENSE_AGENT_CHAT',
  CLOSE_EXPENSE_AGENT_CHAT: 'CLOSE_EXPENSE_AGENT_CHAT',
};
